import { useDispatch } from "react-redux";
import type { AppDispatch } from "../store";

// `AppDispatch` は `import type` で引くため、この module から `../store` への
// 実行時 import エッジは発生しない。副作用モジュール (store 生成・persistStore) に
// 依存する hook 利用箇所が増えても循環参照を作らない。
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
